import React from 'react'

export default () => {
  return (
    <div className="mb-2">
      <a
        href="#language-instructions"
        data-toggle="collapse"
        className="d-block text-center text-md-left"
      >
        Don't see the language you're looking for?
      </a>
      <ul id="language-instructions" className="collapse">
        <li>
          For Federal reporting reasons, certain languages have been omitted, or
          consolidated into smaller groupings. While not ideal in terms of
          accuracy of reporting, please try to match the language listed above
          to the <em>best of your ability</em>.
        </li>
      </ul>
    </div>
  )
}
